import React, { useEffect, useState } from 'react';
import './settings.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import UserColumn from './UserColumn';
import { getSystemData } from '../../System/reducer';
import { loadUserList, loadRoleList } from '../actions';
import { responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import RoleColumn from './RoleColumn';
import ActionColumn from './ActionColumn';

export default function UserAndRoleColumns() {
  const [selectedGroup, setSelectedGroup] = useState(0);
  const { updatePeriod } = useSelector(getSystemData);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const loadData = () => {
    const p1 = dispatch(loadUserList()).catch(responseLogWithNotification);
    const p2 = dispatch(loadRoleList()).catch(responseLogWithNotification);
    return Promise.all([p1, p2]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  return (
    <div className="user-and-role-columns">
      <div className="user-role-menu">
        <TabMenu
          selectedTab={selectedGroup}
          onSelectOptions={item => setSelectedGroup(item.value)}
          options={[
            { value: 0, label: formatMessage({ id: 'users' }) },
            { value: 1, label: formatMessage({ id: 'role' }) },
            { value: 2, label: formatMessage({ id: 'user.activity.log.short' }) },
          ]}
        />
      </div>
      <div className="user-role-content">
        {selectedGroup === 0 ? <UserColumn loadData={loadData} /> : null}
        {selectedGroup === 1 ? <RoleColumn loadData={loadData} /> : null}
        {selectedGroup === 2 ? <ActionColumn loadData={loadData} /> : null}
      </div>
    </div>
  );
}
